@if (progress) {
<div class="progress-bar" [style.width]="progress"></div>
}
<div class="progress-indicator">
    <span>{{ current }} </span>
    <span i18n>van</span>
    <span> {{ total }}</span>
</div>
